import SettingUtils from 'shared/utils/settings'

export function triggerUserFrameworkBookEvent (productId, quantity) {
  const _store = window.store || window.booqableStore
  const state = _store && _store.getState()

  if (quantity === 0) {
    return
  }

  const settings = state.client || state.session
  const currencySettings = settings.get('currency')
  const currency = currencySettings.name || currencySettings.get('name')

  const line = state.orm.lines.filter((line) => {
    return line.item_id === productId
  }).first()
  const event = quantity > 0 ? 'addToCart' : 'removeFromCart'
  const data = {
    value: line.price_each_in_cents / 100,
    currency,
    items: [{
      item_id: line.product.id,
      item_name: line.product.name,
      quantity: Math.abs(quantity),
      price: line.price_each_in_cents / 100
    }]
  }

  window.Booqable._trigger(event, data)
}

export function triggerUserFrameworkViewProductEvent (product) {
  const _store = window.store || window.booqableStore
  const state = _store && _store.getState()
  const settings = state.client || state.session

  const currencySettings = settings.get('currency')
  const currency = currencySettings.iso_code || currencySettings.get('iso_code')

  window.Booqable._trigger('viewProduct', {
    value: product.price_in_cents / 100,
    currency,
    items: [{
      item_id: product.id,
      item_name: product.name,
      quantity: 1,
      price: product.price_each_in_cents / 100
    }]
  })
}

export function setUserFrameworkCartData () {
  const _store = window.store || window.booqableStore
  const state = _store && _store.getState()

  const cart = state.orm.carts.getById(state.client?.cartId) || state.orm.carts.first()
  const coupon = cart && cart.coupon_id && state.orm.coupons.getById(cart.coupon_id)
  const settings = state.client || state.session

  const currencySettings = settings.get('currency')
  const currency = currencySettings.name || currencySettings.get('name')

  if (cart) {
    const data = {
      cartId: cart.id,
      orderId: cart.order_id,
      deposit: cart.deposit_in_cents / 100,
      couponDiscount: cart.coupon_discount_in_cents / 100,
      toBePaid: cart.to_be_paid_in_cents / 100,
      totalDueLater: cart.total_due_later_in_cents / 100,
      grandtotal: cart.grand_total_in_cents / 100,
      grandTotalWithTax: cart.grand_total_with_tax_in_cents / 100,
      tax: cart.tax_values.map((taxValue) => taxValue.value_in_cents / 100)
        .reduce((prev, current) => prev + current, 0),
      coupon: coupon && coupon.identifier,
      items: cart.lines.map((line) => {
        line = typeof line === 'string' ? state.orm.lines.getById(line) : line

        return {
          item_id: line.item_id,
          item_name: line.title,
          quantity: line.quantity,
          price: line.price_each_in_cents / 100
        }
      }),
      currency: currency || 'USD'
    }

    window.Booqable.setCartData(data)
  }
}

export function initShopTracking () {
  const Booqable = window.Booqable

  const googleAnalytics = SettingUtils.get('store.google_analytics_id')
  const facebookPixel = SettingUtils.get('store.facebook_pixel_id')

  if (googleAnalytics) {
    Booqable._setupGoogleAnalyticsDefaultEvents()
  }

  if (facebookPixel) {
    Booqable._setupFacebookDefaultEvents()
  }

  setUserFrameworkCartData()
}
